export default __webpack_public_path__ + "static/media/s4.b901e475.png";